import { gql } from "@apollo/client"

export const WorkStatusSectionFragment = gql`
    fragment WorkStatusSection_user on BaseUserInterface {
        id
        workStatus
        workStatusUpdatedAt
    }
`
